var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import api from "../../utils/api/api.utils";
import { append } from "../../utils/api.utils";
import { generateApi } from "../generators/generator.api";
import { GENERATOR_PARAMS } from "./rentRegistration.constants";
export var getDetail = (_a = generateApi(GENERATOR_PARAMS), _a.getDetail), getCount = _a.getCount, create = _a.create, update = _a.update, remove = _a.remove;
export var getPaged = function (params) {
    var query = params.query;
    return api.get(append("/".concat(GENERATOR_PARAMS.basePathEntity), __assign(__assign({}, query), { sort: query.sort })), { isV2: true });
};
export var retryBrusselsRegistration = function (rentRegistrationId) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(rentRegistrationId, "/send-to-brussels"), {
        data: {},
    });
};
export var retryMyRentRegistration = function (rentRegistrationId, data) {
    return api.post("/".concat(GENERATOR_PARAMS.basePathEntity, "/").concat(rentRegistrationId, "/retry"), {
        data: data,
    });
};
